import * as angular from "angular";
import {BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME} from "../../angular/constants/commons";

angular
  .module('bringoz.admin.commons')
  .directive('bringozIdGenerator', bringozIdGenerator);

function bringozIdGenerator() {
  return {
    restrict: 'A',
    link: (scope, elem, attr) => {
      attr.$set(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, `${attr.bringozIdGenerator}`);
    }
  };
}
